import { useTranslation } from "react-i18next";
import { Briefcase, Calendar } from "iconsax-react";
import { Button } from "@/shared/ui";
import { formatDateForDisplay } from "@/shared/utils";
import type { ContractorProfile } from "../types";
import ProfileDataRow from "./ProfileDataRow";
import ContractorOnboardingCard from "./ContractorOnboardingCard";

interface ContractInfoSectionProps {
  profile: ContractorProfile;
  mustChangePassword: boolean;
}

export default function ContractInfoSection({ profile, mustChangePassword }: ContractInfoSectionProps) {
  const { t } = useTranslation("EmployeePortal");

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col">
        <h2 className="text-display-2xs content-base-primary mb-7">{t("overview.contractInfo.title")}</h2>
        <div className="flex flex-col">
          <ProfileDataRow icon={Briefcase} label={t("overview.contractInfo.serviceName")} value={profile.service_name} />
          <ProfileDataRow
            icon={Calendar}
            label={t("overview.contractInfo.contractDate")}
            value={formatDateForDisplay(profile.contract_date)}
          />
          {profile.contract_end_date && (
            <ProfileDataRow
              icon={Calendar}
              label={t("overview.contractInfo.contractEndDate")}
              value={formatDateForDisplay(profile.contract_end_date)}
            />
          )}
        </div>
      </div>

      {profile.gph_contract_url && (
        <Button
          variant="secondary"
          onClick={() => window.open(profile.gph_contract_url!, "_blank")}>
          {t("overview.contractInfo.signContract")}
        </Button>
      )}

      {!mustChangePassword && <ContractorOnboardingCard />}
    </div>
  );
}

